(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slofe-bowl-dialog"]) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-slofe-open]');
      if (!opener) return;
      const dialog = document.getElementById(opener.dataset.slofeOpen);
      if (!dialog) return;
      const previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow; opener.focus(); }, { once: true });
      if (!initialized.has(dialog)) {
        initialized.add(dialog);
        dialog.querySelector('[data-slofe-close]').addEventListener('click', () => dialog.close());
      }
      const section = dialog.querySelector('[data-slofe-slowfeed]');
      if (section.dataset.loading) return;
      section.dataset.loading = 'true';
      const script = document.createElement('script');
      script.type = 'module';
      script.src = section.dataset.bundle;
      script.onerror = () => {
        delete section.dataset.loading;
        script.remove();
        section.querySelector('[data-slofe-editor]').textContent = 'Der Editor konnte nicht geladen werden. Bitte schließe dieses Fenster und öffne es erneut.';
      };
      document.head.appendChild(script);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slofe-name-dialog"]) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-name-open]');
      if (!opener) return;
      const dialog = document.getElementById(opener.dataset.nameOpen);
      if (!dialog || dialog.open) return;
      const previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        opener.focus();
      }, { once: true });
      if (!dialog.dataset.bound) {
        dialog.dataset.bound = 'true';
        dialog.querySelector('[data-name-close]').addEventListener('click', () => dialog.close());
      }
      const host = dialog.querySelector('[data-slofe-name]');
      if (host.dataset.loading) return;
      host.dataset.loading = 'true';
      const script = document.createElement('script');
      script.type = 'module';
      script.src = host.dataset.bundle;
      script.onerror = () => {
        delete host.dataset.loading;
        script.remove();
        host.querySelector('p').textContent = 'Der Editor konnte nicht geladen werden. Bitte schließe dieses Fenster und öffne es erneut.';
      };
      document.head.appendChild(script);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
